import React from "react";
import BaseYieldList from "./base-yield-list";
import { messages } from "../i18n-messages";
import { useReportCropScope } from "../data/selectors";

const CropYieldList = (props: Record<string, any>): JSX.Element => {
    const cropScope = useReportCropScope();

    return (
        <BaseYieldList
            addGoalMessage={messages.addCropYieldGoal}
            goalPlaceholderMessage={messages.yieldGoal}
            breakEvenMode={false}
            cropScope={cropScope}
            {...props}
        />
    );
};
export default CropYieldList;
